export default "__VITE_ASSET__gI5MlXk0__"